import { getCnvGeneOverlapsData } from '@/@core/services/app.service'
import { isWindow } from '@/@core/utils/utils'
import { Refresh, Search } from '@mui/icons-material'
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Fade,
  Grid,
  Grow,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

interface Props {
  data: any[]
  id: number
}

const geneName_List = [] as string[]
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const CnvGeneDisplay = (props: Props) => {
  const { t } = useTranslation()
  const [mainHeight, setMainHeight] = React.useState(0)
  const [checked, setChecked] = React.useState(false)
  const [searchValue, setSearchValue] = React.useState({
    geneNameIn: [] as string[],
    chrom: [] as {
      value: string
      text: string
    }[]
  })
  const [cnvGeneOverlapsData, setCnvGeneOverlapsData] = React.useState<any[]>(
    []
  )

  const fetchCnvGeneOverlapsData = useMutation({
    mutationFn: async (id: number) => await getCnvGeneOverlapsData(id),
    onSuccess: (data: any, params) => {
      //post返回的结果
      if (data) {
        // getCnvManual.mutateAsync(params.id)

        setCnvGeneOverlapsData(data)
      }
    }
  })

  const handleListChange = (value: any, name: string) => {
    setSearchValue({
      ...searchValue,
      [name]: value
    })
  }

  React.useEffect(() => {
    if (props.id) fetchCnvGeneOverlapsData.mutateAsync(props.id)
    const mains = document.getElementsByTagName('main')

    if (mains && Array.from(mains) && Array.from(mains).length) {
      const main = Array.from(mains)[0]

      //
      const clientHeight = main.clientHeight

      setMainHeight(clientHeight - 80)
    }
  }, [props.id])

  const Item = ({ items, index }: { items: any; index: number }) => {
    const [checked, setChecked] = React.useState(index === 0)

    return (
      <Grid container spacing={3}>
        <Grid item xs={3} sm={2} md={1} key={items.chrom}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              margin: '5px 0',
              textTransform: 'uppercase',
              minHeight: 40
            }}
            onClick={() => setChecked(!checked)}
          >
            {`Chr${items.chrom}`}
          </Button>
        </Grid>

        {items.genes.map((item: any, itemIndex: number) => (
          <Grid
            item
            xs={3}
            sm={2}
            md={1}
            key={`${items.chrom}-${item.name}-${itemIndex}`}
            sx={{
              display: checked ? 'block' : 'none'
            }}
          >
            <Button
              sx={{ margin: '5px 0', minHeight: 40 }}
              variant="outlined"
              fullWidth
            >
              {item.name}
            </Button>
          </Grid>
        ))}
      </Grid>
    )
  }

  return (
    <Box>
      <Card
        sx={{
          margin: '20px 0'
        }}
      >
        <CardContent>
          <Box
            maxHeight={mainHeight ? `${mainHeight - 230}px` : 500}
            overflow="auto"
          >
            <Box>
              {cnvGeneOverlapsData.map((items, index) => (
                <Item items={items} key={items.chrom} index={index} />
              ))}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default CnvGeneDisplay
